import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ytsearch from '../assets/ytsearch.svg'
import ytupload from '../assets/ytsearch.svg'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);
//Vuetify.config.silent = true
export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: colors.shades.black,
            secondary: colors.grey.darken1,
            accent: colors.shades.black,
            error: colors.red.accent3,
            anchor: '#030303',
          },
        },
      },
    icons: {
        iconfonts: 'custom-icons',
        values: {
          customIconSvg: ytsearch,
          customIconSvgPath: 'M16.296 16.996a8 8 0 11.707-.708l3.909 3.91-.707.707-3.909-3.909ZM18 11a7 7 0 11-14 0 7 7 0 0114 0Z',
          ytUploadSvg:ytupload,
          ytUploadSvgPath:"M14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2zm3-7H3v12h14v-6.39l4 1.83V8.56l-4 1.83V6m1-1v3.83L22 7v8l-4-1.83V19H2V5h16z"
        },
      },
});
